import { render, staticRenderFns } from "./CardTarjaEnqueteTaOnWithQRCode.vue?vue&type=template&id=61059742&scoped=true"
import script from "./CardTarjaEnqueteTaOnWithQRCode.vue?vue&type=script&lang=js"
export * from "./CardTarjaEnqueteTaOnWithQRCode.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaEnqueteTaOnWithQRCode.vue?vue&type=style&index=0&id=61059742&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61059742",
  null
  
)

export default component.exports